import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import VueRouter from 'vue-router'
import LoadScript from 'vue-plugin-load-script'
import { createPinia, PiniaVuePlugin } from 'pinia'
import VueLazyload from 'vue-lazyload'
import { WevePlugin } from '@weve/ui'
import '@weve/ui/dist/style.css'
import VueMeta from 'vue-meta'

import router from './router'
import App from './App.vue'

import './styles/index.scss'
import './styles/tailwind.css'

Vue.config.productionTip = false

Vue.use(WevePlugin)
Vue.use(VueLazyload, {
  lazyComponent: true,
})
Vue.use(VueCompositionAPI)
Vue.use(PiniaVuePlugin)
Vue.use(LoadScript)
const pinia = createPinia()
Vue.use(VueRouter)
Vue.use(VueMeta)

new Vue({
  router,
  pinia,
  render: (h) => h(App),
}).$mount('#app')
